export const GET_PROJECTS = 'projects/GET_PROJECTS';
export const GET_PROJECTS_SUCCESS = 'projects/GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_ERROR = 'projects/GET_PROJECTS_ERROR';
export const TOGGLE_PROJECT_STAR = 'projects/TOGGLE_PROJECT_STAR';
export const GET_SINGLE_PROJECT = 'projects/GET_SINGLE_PROJECT';
export const GET_SINGLE_PROJECT_SUCCESS = 'projects/GET_SINGLE_PROJECT_SUCCESS';
export const GET_SINGLE_PROJECT_ERROR = 'projects/GET_SINGLE_PROJECT_ERROR';
export const RESET_SINGLE_PROJECT = 'projects/RESET_SINGLE_PROJECT';
export const UPDATE_SINGLE_PROJECT = 'projects/UPDATE_SINGLE_PROJECT';
